import React from 'react';
import { useSelector } from 'react-redux';
import { Space } from 'antd';
import { AI_ALERT_SEVERITY_TAGS, AI_ALERT_ACTIVE_TAG } from '@utils/aiAlerts/mapping';
import { featureSelector , aiAlertsMetricsMetaSelector } from '@store/common/selectors';
import featureNames from '@utils/featureToggle/constants';
import { filterBasedOnTabType, groupAiAlertMetrics } from '@utils/aiAlerts/utils';
import ActiveTag from './tag/ActiveTag';
import MetricTag from './tag/MetricTag';
import SeverityTag from './tag/SeverityTag';
import { Wrapper, Divider } from './styled';

const TagsContainer = ({
  type,
  alertsBySeverity,
  alertsByMetric,
  alertFeatureFlags,
  alertsByActiveStatus,
}) => {
  const getSeverityTags = () => {
    const validTags = filterBasedOnTabType(AI_ALERT_SEVERITY_TAGS, type);
    return validTags.map((tag, index) => (
      <SeverityTag key={index} tag={tag} value={alertsBySeverity[tag.key]} />
    ));
  };

  const getActiveTag = () => {
    const validTags = filterBasedOnTabType(AI_ALERT_ACTIVE_TAG, type);
    return validTags.map(() => (
      <ActiveTag key="active-alerts" value={alertsByActiveStatus[type]} />
    ));
  };

  const getValidMetricsBasedOnFeatureFlag = (validMetrics) => {
    const { isAdAlertsEnabled, isContentAlertsEnabled, isAppAlertEnabled } = alertFeatureFlags;
    const { adMetrics, appMetrics, contentMetrics } = groupAiAlertMetrics(validMetrics);

    return [
      ...(isContentAlertsEnabled ? contentMetrics : []),
      ...(isAdAlertsEnabled ? adMetrics : []),
      ...(isAppAlertEnabled ? appMetrics : []),
    ];
  };

  const GetMetricTags = () => {
    const aiAlertsMetricsMeta = useSelector(aiAlertsMetricsMetaSelector);
    const allowedMetrics = useSelector(featureSelector(featureNames.ALL_METRICS));
    const allowedAIAlertMetrics = aiAlertsMetricsMeta.filter((metric) =>
      allowedMetrics.includes(metric.metricKey),
    );
    const validTags = filterBasedOnTabType(allowedAIAlertMetrics, type);

    const validMetrics = getValidMetricsBasedOnFeatureFlag(validTags);

    return validMetrics.map((tag, index) => (
      <MetricTag key={index} tag={tag} value={alertsByMetric[tag.pulse4Key]} />
    ));
  };

  return (
    <Wrapper>
      <Space>{getActiveTag()}</Space>
      <Divider />
      <Space>{getSeverityTags()}</Space>
      <Space>{GetMetricTags()}</Space>
    </Wrapper>
  );
};

export default TagsContainer;
